import Button from 'components/common/forms/Button';
import ButtonLoading from 'components/common/forms/ButtonLoading';
import Modal, { ModalHeader } from 'components/common/Modal';

export interface DeveloperConfirmationRow {
  label: string;
  value: React.ReactNode | string;
}

export const DeveloperConfirmationModal = ({
  confirmLabel = 'Confirm',
  isConfirmDisabled = false,
  isConfirming = false,
  onCloseModal,
  onConfirm,
  rows,
  title,
}: {
  confirmLabel?: string;
  isConfirmDisabled?: boolean;
  isConfirming?: boolean;
  onCloseModal(): void;
  onConfirm(): void;
  rows: DeveloperConfirmationRow[];
  title: string;
}): JSX.Element => {
  return (
    <Modal
      header={<ModalHeader onClickClose={onCloseModal}>{title}</ModalHeader>}
      onCloseModal={onCloseModal}
      position="top"
    >
      <dl className="divide-y divide-gray-d-200">
        {rows.map((row) => (
          <div key={row.label} className="flex justify-between py-2 text-sm">
            <dt className="text-gray-d-600">{row.label}</dt>
            <dd className="font-medium text-gray-d-900">{row.value}</dd>
          </div>
        ))}
      </dl>

      <div className="mt-8 flex gap-3 flex-row-reverse">
        <ButtonLoading
          disabled={isConfirmDisabled}
          grow
          hierarchy="primary"
          isLoading={isConfirming}
          onClick={onConfirm}
          size="lg"
          type="button"
        >
          {confirmLabel}
        </ButtonLoading>
        <Button
          grow
          hierarchy="secondary-gray"
          onClick={onCloseModal}
          size="lg"
          type="button"
        >
          Cancel
        </Button>
      </div>
    </Modal>
  );
};
